export const REDIRECT_URL_QUERY_PARAM = 'redirectUrl';
export const REDIRECT_APP_QUERY_PARAM = 'redirectApp';
